export default {
  name: "AppContent",

  props: {
    iframe: Boolean,
    tag: {
      type: String,
      default: "main"
    }
  },

  computed: {
    styles() {
      const { bar, top, right, footer, bottom, left } = this.$core.application;

      return {
        paddingTop: `${top + bar}px`,
        paddingRight: `${right}px`,
        paddingBottom: `${footer + bottom}px`,
        paddingLeft: `${left}px`
      };
    }
  },

  render(h) {
    return h(
      this.tag,
      {
        staticClass: "content",
        style: this.styles,
        ref: "content",
        class: {
          content_iframe: this.iframe
        }
      },
      [h("div", { staticClass: "content__wrap" }, this.$slots.default)]
    );
  }
};
